import { colors } from './colors';

/** Dark mode editor background */
export const monokaiBackground = '#272822';
export const monokaiBackgroundOffset = '#2F3129';
export const monokaiCommentColor = '#ababab';

/** Page background in dark mode */
export const darkModeBackground = '#151515';

const darkThemeHeader = {
  background: colors.fsDarkBlue,
  // background: '#27323E',
  // background: '#27323F',
  link: {
    color: colors.white,
    colorHover: colors.fsCyan,
    // colorHover: '#3265B0',
  },
  icon: {
    color: colors.white,
  },
};

// primary button colors
const button = {
  background: colors.fsDarkBlue,
  backgroundHover: colors.fsDarkBlueHoverLight,
  backgroundSelected: colors.checkmark,
  backgroundDisabled: colors.fsDarkBlueDisabled,
  border: colors.fsDarkBlue,
  borderHover: colors.fsDarkBlueHoverLight,
  borderSelected: colors.checkmark,
  borderDisabled: colors.fsDarkBlueDisabled,
  label: colors.white,
};

// Check and radio boxes
const selectionBox = {
  color: colors.gray2,
  border: colors.gray2,
  label: colors.fsLightBlue,
  background: darkModeBackground,
  checked: { color: colors.fsCyan, border: colors.fsCyan },
  disabled: { label: colors.gray2 },
};

// Dropdown menues
const dropdown = {
  background: monokaiBackground,
  backgroundHover: colors.black,
  border: colors.black,
  label: colors.fsCyan,
};

// Code editor colors
const ace = {
  comment: '#ACAFB3',
};

const playControls = {
  background: '#000000',
  backgroundHover: '#444444',
  backgroundDisabled: monokaiBackground,
  color: colors.fsCyan,
};

const tabs = {
  label: colors.gray2,
  labelActive: colors.fsCyan,
  background: monokaiBackgroundOffset,
  backgroundActive: monokaiBackground,
  border: monokaiBackground,
};

const modal = {
  background: monokaiBackground,
  separator: colors.black,
  border: colors.fsCyan,
};

export const darkTheme = {
  primary: monokaiBackground,
  primaryHover: '#828891',
  primaryDisabled: monokaiBackgroundOffset,
  secondary: '#3A4556',
  header: colors.fsCyan,
  label: colors.white,
  text: colors.white,
  // primaryBorder: '#828891',
  // primaryHeader: '#FFFFFF',
  // primaryText: '#A2A4A8',
  // primarySelected: '#3E84EB',
  // primaryDisabled: '#72889C',
  pageHeader: darkThemeHeader,
  pageFooter: darkThemeHeader,
  pageBackground: darkModeBackground,
  playControls,
  button,
  selectionBox,
  dropdown,
  ace,
  tabs,
  modal,
};
